import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import { Button, Card, Grid } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import dayjs from 'dayjs'
import { message } from 'antd'

import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import { PipelineFormModal } from './components/PipelineFormModal'
import useAxios from '../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../types/pagination'
import PipelineFilter, { IFilterMapped } from './components/PipelineFilter'
import PipelineTable from './components/PipelineTable'
import PageUrls from '../../../../constants/page-urls'
import { IPipeline } from '../../../../types/pipeline'

const Menus: any[] = []

const PipelinePage = () => {
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)

  const [isModalCreatePipeline, setIsModalCreatePipeline] =
    useState<boolean>(false)
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: Number(queryStr.perPage ?? 15),
    search: queryStr.search?.length
      ? String(queryStr.search).toLowerCase()
      : undefined,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : undefined,
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : undefined,
  })

  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      setFilter(newFilter)
    },
    [setFilter],
  )

  const handleSearch = (newFilter: IFilterMapped) => {
    const filter = {
      ...newFilter,
      page: 1
    }
    setFilter(filter)
    setSearchFilter(filter)
    const newQuery = queryString.stringify({ ...filter })
    navigate(`${PageUrls.CRM.Pipeline}?${newQuery}`, {
      replace: true,
    })
  }

  const handlePageChange = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.CRM.Pipeline}?${newQuery}`, {
      replace: true,
    })
  }


  useEffect(() => {
    handleSearch(filter)
  }, [])

  const pipelineList = useAxios<PaginationResponseInterface<IPipeline>>({
    method: 'GET',
    url: '/pipeline',
    params: {
      ...searchFilter,
      displayType:
        (searchFilter.displayType as any) == 'all'
          ? undefined
          : searchFilter.displayType,
    },
  })

  const onUpdatePipelineListSuccess = useCallback(async () => {
    try {
      await pipelineList.mutate()
    } catch (error) {
      message.error('ไม่สามารถดึงข้อมูล Lead Pipeline ได้')
    }
  }, [pipelineList])

  return (
    <ContentWrapper>
      <Helmet title="Lead Pipeline" />
      <PipelineFormModal
        isOpen={isModalCreatePipeline}
        onClose={(visible: boolean) => setIsModalCreatePipeline(visible)}
        onUpdatePipelineListSuccess={onUpdatePipelineListSuccess}
      />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="Lead Pipeline"
            routes={Menus}
            descriptions="Lead Pipeline"
          />
        </Grid>
        <Grid item mb={2}>
          <Button
            variant="contained"
            size="large"
            startIcon={<AddIcon />}
            onClick={() => setIsModalCreatePipeline(true)}
          >
            Pipeline
          </Button>
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        <PipelineFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
        />
        <PipelineTable
          isLoading={pipelineList.isLoading}
          data={pipelineList.data?.records}
          mutate={pipelineList.mutate}
          onUpdatePipelineListSuccess={onUpdatePipelineListSuccess}
          filter={filter}
          onSearch={handleSearch}
          handlePageChange={handlePageChange}
          total={pipelineList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default PipelinePage
